import { getItem } from "app/utils/session";

export const getCylinderPayload = ({ ...rest }) => {
    const authToken = getItem("token");
    const payload = { authToken, ...rest }
    return payload
}